export const employees = [
  { name: "安永 伊織" },
  { name: "岡野 真士" },
  { name: "グエン　フー ヒィウ" },
  { name: "宮川 隼" },
  { name: "松岡 愛奈" },

  { name: "安藤　直樹" },
  { name: "杉本　眞司" },
  { name: "唐澤　雅徳" },
  { name: "池田　さやか" },
  { name: "中原　千登世" },
  { name: "佐久間　大典" },
  { name: "栗崎　智裕" },
  { name: "HOANG VAN THANG" },
  { name: "栗原　幸夫" },
  { name: "榎本　伊栞" },
  { name: "山村　由紀子" },
  { name: "橋元　美智代" },
  { name: "鈴木　もも" },
  { name: "清水　健次" },
  { name: "倉石　晃壮" },
  { name: "小坂　優菜" },
  { name: "小松　美瑠" },
];
